import treeSelect from './tree-select.vue'

treeSelect.install = function(Vue) {
  Vue.component(treeSelect.name, treeSelect)
}

export default treeSelect
